
            const data = {"name":"task-icon","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M3 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1ZM4 12a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1ZM5 17a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2H5Z\" _fill=\"#6A1B9A\"/>","originalColors":[{"type":"fill","color":"#6A1B9A"}],"stopColors":[]}}
        
                    module.exports = data
                    